export const LoginPageUrl = '/'; // 로그인 페이지
export const SignupPageUrl = '/signup'; // 로그인 페이지
export const PrivacyPolicyPageUrl = '/signup/privacy_policy'; // 개인정보수집동의
export const PrivacyInfoPageUrl = '/signup/privacy_info'; // 개인정보수집동의
export const FindIdPageUrl = '/find-id'; // 아이디 찾기
export const ResultIdPageUrl = '/result-id'; // 아이디 결과 페이지
export const FindPasswordPageUrl = '/find-Password'; // 비밀번호 찾기 페이지
export const ResultPasswordPageUrl = '/result-Password'; //  비밀번호 결과 페이지
export const StuffPageUrl = '/stuff'; // 매물 페이지
export const DiagnosisPageUrl = '/diagnosis'; // 진단 페이지
export const NoticePageUrl = '/notice'; // 게시판 페이지
export const MyPageUrl = '/my-page'; // 관리자 등록 페이지
export const AdminPageUrl = '/admin'; // 공지사항 등록 페이지
